import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { TabelHeadingTxt } from "../../Text/TabelCommonTxt";
import { Divider, Text, useColorMode } from "theme-ui";
import DataTable from "../../Tabels/Tabel";
import { useEffect, useMemo, useState } from "react";
import plus from "../../assets/images/Icon/plus.svg";
import { ColumnDef } from "@tanstack/react-table";
import TableActions from "../Roles/TableActions";
import queryString from "query-string";
import { getApiEndPoint } from "../../../utils/GenerateQueryString";
import { getAllTeams, getAllUserWithoutPagination } from "../../../store/actions/user.action";
import { usePreviousURL } from "../../../utils/CustomHandler";
import theme from "../../../theme";

const Teams: React.FC = () => {
    const { teams, loader, userData } = useSelector((state: any) => state.user);
    console.log('chk17', userData);

    const { paginations } = useSelector((state: any) => state.pagination);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<boolean>(true);
    const previousURL = usePreviousURL()
    const [colorMode] = useColorMode();
    const titleColor = (colorMode === "light" ? theme.colors?.secondary : "#8d8d8d") as string;
    useEffect(() => {
        dispatch(getAllUserWithoutPagination())
    }, [dispatch])
    useEffect(() => {
        let apiEndPoint = getApiEndPoint({ limit, currentPage }, location.search, columns?.map((val: any) => ({ accessorKey: val.accessorKey, filterType: val.filterType })) || [])

        dispatch(getAllTeams(apiEndPoint))
        setRefresh(false);
    }, [refresh, location?.search, limit, currentPage])

    const handleclick = () => {
        navigate("/create-team")
    }
    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: 'No',
            enableColumnFilter: false,
            accessorKey: "no",
            cell: ({ row }) => {
                return (
                    <Text variant='Poppins14Normal24lh'>{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            },
        },
        {
            accessorKey: "teamName",
            header: 'Team Name',
            cell: ({ row }) => {
                console.log('chk78', row.original);

                return (
                    <Text onClick={() => { previousURL(`/edit-team/${row?.original?._id}`) }} style={{ textDecoration: 'underline', color: titleColor, cursor: "pointer", fontWeight: 500 }}>
                        {row?.original?.
                            teamName
                            || ''}
                    </Text>)
            },
            enableColumnFilter: true,
            filterType: "textbox",

        },

        {
            header: 'Team Leader',
            accessorKey: "teamLeader",
            cell: ({ row }) => {
                const teamlead = row.original.teamLeader;
                return (
                    <Text >
                        {teamlead?.FirstName} {teamlead?.LastName}
                    </Text>
                );
            },
            filterType: 'dropdown',
            options: userData?.data?.map((val: { _id: string, FirstName: string, LastName: string }) => ({ value: val._id, label: `${val.FirstName} ${val.LastName}` }))
        },

        {
            header: 'Team Members',
            accessorKey: "membersCount",
            cell: info => info.getValue(),
        },
        {
            header: 'Sub Teams',
            accessorKey: "subTeamCount",
            cell: info => info.getValue(),
        },
        {
            header: 'Accessor',
            accessorKey: "Accessor",
            enableColumnFilter: false,
            cell: ({ row }) => {
                return (
                    <TableActions row={row} editTo={`/edit-team/${row?.original?._id}`} viewTo="/my-team" showView={true} deleteMessage='Are you sure you want to delete this team?' deleteApi={`teams/deleteTeam/${row?.original?._id}`} toggleRefresh={() => setRefresh(true)} />
                )
            },
        }
    ], [teams?.data]);
    return (
        <div className='main-content'>
            <TabelHeadingTxt Title='Teams' Count={teams?.count} BtnTxt='Create Team' onClick={handleclick} src={plus} sx={{ backgroundColor: '#7743DB', color: 'white' }} />
            <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
            <DataTable
                loader={loader}
                columns={columns}
                data={teams?.data || []}
                TotalLength={teams?.count || 15}
                perPageCount={limit || 15}
                currentPage={paginations.currentPage}
                onPerPageChange={(itemsPerPage) => {
                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            limit: itemsPerPage.toString(),
                        });
                    } else if (teams?.count < itemsPerPage) {
                        setSearchParams({
                            currentPage: '1',
                            limit: itemsPerPage.toString(),
                        });
                    }
                    else {
                        setSearchParams({
                            currentPage: currentPage.toString(),
                            limit: itemsPerPage.toString(),
                        });
                    }

                }}
                onPageChange={(value: string) => {
                    console.log(value, "onPageChange");

                    if (searchParams?.size > 2) {
                        const parsedQuery = queryString.parse(location.search);

                        setSearchParams({
                            ...parsedQuery,
                            currentPage: value.toString(),
                        });
                    } else {
                        setSearchParams({
                            currentPage: value.toString(),
                            limit: limit.toString(),
                        });
                    }

                }}

            />
        </div>
    )
}

export default Teams